<template>
  <BreadCrumbsNavbar
    :menu-pages="settingsBreadCrumbsLinks"
    :columns="2"
    :is-loading="isLoading"
  />
</template>

<script setup>
import { storeToRefs } from 'pinia';
import BreadCrumbsNavbar from '@/components/shared/BreadCrumbsNavbar.vue';
import { useAppPlatform } from '@/stores/app/platform';

defineProps({
  isLoading: { type: Boolean, default: false },
});

const platformStore = useAppPlatform();
const { settingsBreadCrumbsLinks } = storeToRefs(platformStore);
</script>
